<div [formGroup]="seasonFormGroup"
     fxLayout="row wrap"
     fxLayoutGap="12px grid">

    <ng-container *ngIf="headline && !slimmedView">
        <div fxFlex=100>
            <h2>{{headline}}</h2>
        </div>
    </ng-container>

    <ng-container *ngIf="topList?.length || bottomList?.length">
        <div fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field fxFlex [appearance]="appearance" floatLabel="always">
                    <mat-label>Saison</mat-label>
                    <input type="text" matInput data-test="FI-Nach Saison suchen..."
                           formControlName="season"
                           [matAutocomplete]="seasonSelector">
                    <button matSuffix
                            mat-icon-button
                            type="button"
                            color="warn"
                            matTooltip="Ausgewählte Saison entfernen"
                            [disabled]="!season?.id"
                            (click)="onClickRemoveSeason()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                    <mat-error [hidden]="slimmedView">{{seasonFormGroup.get('season').errors | firstErrorMessage}}</mat-error>
                </mat-form-field>

                <mat-autocomplete #seasonSelector="matAutocomplete" [displayWith]="displaySeasonWith" (optionSelected)="seasonChangedManually.emit()">
                    <ng-container *ngIf="filteredTopList$ | async as topList">
                        <mat-optgroup label="Aktuelle Saison">
                            <ng-container *ngFor="let season of topList">
                                <mat-option [value]="season">
                                    {{season.name}}<br>
                                    <small>{{season.startDate | dateFormat: {format: 'dd.MM.'} }}
                                        - {{season.endDate | dateFormat: {format: 'dd.MM.'} }}</small>
                                </mat-option>
                                <ng-container *ngIf="!topList?.length">
                                    Es gibt keine aktuelle Saison
                                </ng-container>
                            </ng-container>
                        </mat-optgroup>
                    </ng-container>

                    <ng-container *ngIf="filteredBottomList$ | async as bottomList">
                        <mat-optgroup label="Weitere Saisons">
                            <ng-container *ngFor="let season of bottomList">
                                <mat-option [value]="season">
                                    {{season.name}}<br>
                                    <small>{{season.startDate | dateFormat: {format: 'dd.MM.'} }}
                                        - {{season.endDate | dateFormat: {format: 'dd.MM.'} }}</small>
                                </mat-option>
                                <ng-container *ngIf="!bottomList?.length">
                                    Keine Saison gefunden
                                </ng-container>
                            </ng-container>
                        </mat-optgroup>
                    </ng-container>
                </mat-autocomplete>
            </div>
        </div>
    </ng-container>

</div>
